/**
 * Kbd — keyboard shortcut hint chip.
 */

import { cn } from '../../lib/utils';

export default function Kbd({
  className,
  ...props
}: React.HTMLAttributes<HTMLElement>) {
  return (
    <kbd
      className={cn(
        'inline-flex items-center gap-0.5 rounded-md px-1.5 py-0.5',
        'border border-neutral-200 dark:border-neutral-700',
        'bg-neutral-50 dark:bg-neutral-800',
        'text-[10px] font-medium font-mono text-muted-foreground',
        'shadow-[inset_0_-1px_0_rgba(0,0,0,0.06)] dark:shadow-none',
        className
      )}
      {...props}
    />
  );
}
